<template>
  <NuxtLink class="vacancy-new-card" :to="`/vacancies/${card.id}`" target="_blank">
    <div class="header">
      <h3 class="name">{{ card.position_name }}</h3>
      <span class="salary">{{ card.formatted_salary }}</span>
    </div>

    <span class="company-name">{{ card.organization_value }}</span>

    <div class="description">{{ card.responsibilities }}</div>

    <div class="requirements">
      <span class="name-field">Требования: </span>
      {{ card.experience_value }}
    </div>

    <ul class="requirements-list">
      <li v-if="card.region_value" class="item">
        <div class="icon">
          <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M10.0799 7.08537C10.0799 8.23204 9.15326 9.16537 7.99992 9.16537C6.84659 9.16537 5.91992 8.2387 5.91992 7.08537C5.91992 5.93204 6.85326 5.00537 7.99992 5.00537C8.22659 5.00537 8.44659 5.0387 8.64659 5.10537"
              stroke="#1CCB01"
              stroke-width="1.33333"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              class="path-change"
              d="M3.98632 3.07862C6.89965 0.338622 12.5463 1.27862 13.5863 5.88529C14.353 9.27196 12.2463 12.1386 10.3997 13.912C9.05965 15.2053 6.93965 15.2053 5.59298 13.912C3.75298 12.132 1.63965 9.26529 2.41298 5.87862"
              stroke="black"
              stroke-width="1.33333"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </div>
        <div class="information">
          <span class="label">Регион</span>
          <span class="value">{{ card.region_value }}</span>
        </div>
      </li>
      <li v-if="card.housing_value" class="item">
        <div class="icon">
          <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M9 6.21191H7C5.9 6.21191 5 7.11191 5 8.21191V10.2119C5 11.3119 5.9 12.2119 7 12.2119H9C10.1 12.2119 11 11.3119 11 10.2119V8.21191"
              stroke="#1CCB01"
              stroke-width="1.33333"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              class="path-change"
              d="M8 6.21191V12.2119"
              stroke="black"
              stroke-width="1.33333"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              class="path-change"
              d="M5 9.21191H11"
              stroke="black"
              stroke-width="1.33333"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              class="path-change"
              d="M14.6663 7.21219C14.6663 6.40552 14.1263 5.37219 13.4663 4.91219L9.34634 2.02552C8.41301 1.37219 6.91301 1.40552 6.01301 2.10552L2.41967 4.90552C1.81967 5.37219 1.33301 6.36552 1.33301 7.11885V12.0589C1.33301 13.6055 2.59301 14.8722 4.13967 14.8722H11.8597C13.4063 14.8722 14.6663 13.6055 14.6663 12.0655V9.99885"
              stroke="black"
              stroke-width="1.33333"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </div>
        <div class="information">
          <span class="label">Проживание</span>
          <span class="value">{{ card.housing_value }}</span>
        </div>
      </li>
      <li v-if="card.employment_value" class="item">
        <div class="icon">
          <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              class="path-change"
              d="M14.2462 9.54525L14.4729 7.16525C14.6462 5.53858 14.1796 4.21191 11.3329 4.21191H4.66623C1.81956 4.21191 1.35289 5.53858 1.53289 7.16525L2.03289 12.4986C2.17289 13.8052 2.65289 14.8786 5.33289 14.8786H10.6662C13.3462 14.8786 13.8262 13.8052 13.9662 12.4986"
              stroke="black"
              stroke-width="1.33333"
              stroke-miterlimit="10"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              class="path-change"
              d="M5.33301 4.21208V3.67874C5.33301 2.49874 5.33301 1.54541 7.46634 1.54541H8.53301C10.6663 1.54541 10.6663 2.49874 10.6663 3.67874V4.21208"
              stroke="black"
              stroke-width="1.33333"
              stroke-miterlimit="10"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M9.33366 8.87858V9.54525C9.33366 9.55191 9.33366 9.55191 9.33366 9.55858C9.33366 10.2852 9.32699 10.8786 8.00033 10.8786C6.68033 10.8786 6.66699 10.2919 6.66699 9.56525V8.87858C6.66699 8.21191 6.66699 8.21191 7.33366 8.21191H8.66699C9.33366 8.21191 9.33366 8.21191 9.33366 8.87858Z"
              stroke="#1CCB01"
              stroke-width="1.33333"
              stroke-miterlimit="10"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M14.433 7.54541C12.893 8.66541 11.133 9.33208 9.33301 9.55874"
              stroke="#1CCB01"
              stroke-width="1.33333"
              stroke-miterlimit="10"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M1.74707 7.7251C3.24707 8.75176 4.9404 9.37176 6.66707 9.5651"
              stroke="#1CCB01"
              stroke-width="1.33333"
              stroke-miterlimit="10"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </div>
        <div class="information">
          <span class="label">Тип занятости</span>
          <span class="value">{{ card.employment_value }}</span>
        </div>
      </li>
    </ul>

    <div class="date">{{ card.updated }}</div>
  </NuxtLink>
</template>

<script lang="ts" setup>
  import type { VacancyNewCardModel } from '~/models/vacancy'

  defineProps<{
    card: VacancyNewCardModel
  }>()
</script>

<style lang="scss" scoped>
  .vacancy-new-card {
    display: flex;
    flex-direction: column;
    gap: 16px;
    padding: 20px;
    border-radius: 20px;
    border: 1px solid $color-default-black;
    background-color: $color-default-white;
    transition: background-color 0.3s ease-in-out, color 0.3s ease-in-out;

    > .header {
      display: flex;
      flex-direction: column;
      gap: 8px;
    }

    > .header > .name {
      font-size: 18px;
      font-weight: 600;
      line-height: 26px;
    }

    > .header > .salary {
      font-size: 18px;
      font-weight: 600;
      line-height: 26px;
      color: $color-kiwi-50;
    }

    > .company-name {
      font-size: 14px;
      font-weight: 600;
      line-height: 22px;
    }

    > .description {
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 5;
      -webkit-box-orient: vertical;
      overflow: hidden;
      font-size: 12px;
      line-height: 16px;
    }

    > .requirements {
      overflow: hidden;
      font-size: 14px;
      line-height: 22px;
      white-space: nowrap;
      text-overflow: ellipsis;

      > .name-field {
        font-weight: 500;
      }
    }

    > .requirements-list {
      @include list-reset;

      display: flex;
      flex-direction: column;
      gap: 12px;
    }

    > .requirements-list > .item {
      display: flex;
      align-content: center;
      gap: 12px;

      > .icon {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 34px;
        height: 34px;
        border-radius: 50%;
        border: 1px solid #e3e5e8;
      }

      > .information {
        display: flex;
        flex-direction: column;
        gap: 4px;

        > .label {
          display: inline-block;
          font-size: 12px;
          line-height: 16px;
          color: $color-potato-50;
        }

        > .value {
          display: inline-block;
          font-size: 14px;
          font-weight: 600;
          line-height: 22px;
        }
      }
    }

    > .date {
      margin-top: auto;
      font-size: 12px;
      line-height: 16px;
      color: $color-potato-50;
    }

    @media (hover: hover) {
      &:hover {
        color: $color-default-white;
        background-color: $color-default-black;

        > .requirements-list > .item {
          > .icon .path-change {
            stroke: $color-default-white;
          }
        }
      }
    }
  }
</style>
